import { Theme } from '@mui/material/styles';
import merge from 'lodash/merge';
import Autocomplete from './Autocomplete';
import ControlLabel from './ControlLabel';
import Input from './Input';
import Lists from './Lists';
import Menu from './Menu';
import Paper from './Paper';
import Pickers from './Pickers';
import Popper from './Popper';
import Progress from './Progress';
import Select from './Select';
import Table from './Table';
import Tabs from './Tabs';
import TextField from './TextField';
import Typography from './Typography';

export default function ComponentsOverrides(theme: Theme) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return merge(
    Tabs(theme),
    Menu(theme),
    Input(theme),
    Lists(theme),
    Table(theme),
    Paper(),
    Select(),
    Pickers(theme),
    Progress(theme),
    Typography(theme),
    Autocomplete(theme),
    ControlLabel(theme),
    TextField(),
    Popper(),
  );
}
